import React, { useMemo, useState, useCallback } from 'react';
import { Stack, Collapse, IconButton } from '@mui/material';

import {
  StatusChip,
  Typography,
  Divider,
  ExpandMoreIcon,
  ExpandLessIcon,
} from '@occc/ui-design-system';

import { IEaivMembershipStatisticsErrorReason } from '../../../../../dataAccessLayer/eaiv/types';

export interface IEaivAttemptDescriptionProps {
  label: string;
  success: number;
  failed: number;
  reasons: IEaivMembershipStatisticsErrorReason[];
}

export const EaivAttemptDescription: React.FC<IEaivAttemptDescriptionProps> = (props) => {
  const { label, success, failed, reasons } = props;

  const [isOpen, setIsOpen] = useState(false);
  const handleErrorMessagesToggle = useCallback(() => setIsOpen((state) => !state), []);

  const errorReasonsMessage = useMemo(
    () =>
      reasons.map((reason) => (
        <Typography
          variant='caption'
          component='p'
          key={reason.createdAt}
          gutterBottom
        >{`${reason.createdAt}: ${reason.message}`}</Typography>
      )),
    [reasons],
  );

  return (
    <Stack>
      <Stack direction='row' alignItems='center' spacing={1}>
        <Typography variant='caption' minWidth={90}>{`${label}:`}</Typography>
        <StatusChip variant='success' label={`Success: ${success}`} />
        <StatusChip variant='error' label={`Failed: ${failed}`} />
        {Boolean(reasons.length) && (
          <IconButton size='small' onClick={handleErrorMessagesToggle}>
            {isOpen ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
          </IconButton>
        )}
      </Stack>
      {Boolean(reasons.length) && (
        <Collapse in={isOpen}>
          {errorReasonsMessage}
          <Divider />
        </Collapse>
      )}
    </Stack>
  );
};
